module.exports = __webpack_public_path__ + "img/notice_bar@2x.45bb43db.png";